<template>
  <circle cx="6" cy="6" r="6" fill="#2C92FF" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.76771 11.8735C4.76676 11.7508 4.76627 11.6263 4.76627 11.5001V8.48055L4.76655 8.4765C4.7667 8.47501 4.76685 8.47347 4.76685 8.47188C3.72527 8.00341 3 6.96321 3 5.75274C3 4.64796 3.60319 3.68337 4.5 3.16748V5.00012C4.5 5.82855 5.17157 6.50012 6 6.50012C6.82843 6.50012 7.5 5.82855 7.5 5.00012V3.16769C8.39631 3.6838 9 4.64804 9 5.75274C9 6.96321 8.27373 8.00341 7.23309 8.47188L7.23336 8.47592C7.23351 8.47741 7.23367 8.47896 7.23367 8.48055L7.23379 11.5001C7.2338 11.6263 7.23332 11.7508 7.23237 11.8734C6.83462 11.9565 6.42241 12.0001 6 12.0001C5.57762 12.0001 5.16544 11.9565 4.76771 11.8735Z"
    fill="white"
  />
</template>
